import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import "./dashboard.css";
import Navbar from "../../layouts/Navbar";
import Sidebar from "../../layouts/Sidebar";
import Footer from "../../layouts/Footer";

// Create axios instance with default config
const api = axios.create({
  baseURL: 'https://pastq.eddcodesgh.com/qApi/admin/',
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  }
});

const AdminDashboard = () => {
    const history = useNavigate();
    const [loading, setLoading] = useState(true);
    const [analyticsLoading, setAnalyticsLoading] = useState(false);
  
    const emailToken = localStorage.getItem('email');
    const [count, setCount] = useState({
        totalUsers: 0,
        totalUpload: 0,
        totalPay: 0
    });
    
    const [analyticsData, setAnalyticsData] = useState({
        totalViews: 0,
        totalClicks: 0,
        totalEngagements: 0
    });

    const Counts = async () => {
        if (!emailToken) {
            setLoading(false);
            return;
        }
        
        try {
            const result = await api.get(`counts/counts.php`, {
                headers: {
                    "Authorization": "Bearer f0ed28e67f2a90c8bf437f1ff949ef23655e842a2901b7b87779673a0d176506",
                }
            });
            
            if(result.data.status === 200){
                setCount(result.data);
            } else {
                toast.error(result.data.message);
                //history('/');
            }
        } catch (error) {
            if (error.response?.status === 403) {
                toast.error('Invalid API Key');
            } else {
                toast.error('Failed to fetch counts');
            }
        } finally {
            setLoading(false);
        }
    }

    const fetchAnalytics = async () => {
        setAnalyticsLoading(true);
        try {
            const response = await axios.get(`https://pastq.eddcodesgh.com/qApi/admin/analytics/analytics.php?range=7`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer f0ed28e67f2a90c8bf437f1ff949ef23655e842a2901b7b87779673a0d176506",
                },
                withCredentials: true,
            });
            
            if(response.data.status === 200){
                // Extract just the summary data, ignore chart and table data
                if (response.data.data) {
                    setAnalyticsData({
                        totalViews: response.data.data.totalViews || 0,
                        totalClicks: response.data.data.totalClicks || 0,
                        totalEngagements: response.data.data.totalEngagements || 0
                    });
                } else {
                    // If data is at root level
                    setAnalyticsData({
                        totalViews: response.data.totalViews || 0,
                        totalClicks: response.data.totalClicks || 0,
                        totalEngagements: response.data.totalEngagements || 0
                    });
                }
            } else {
                toast.error(response.data.message || 'Failed to load analytics');
                setAnalyticsData({
                    totalViews: 0,
                    totalClicks: 0,
                    totalEngagements: 0
                });
            }
        } catch (error) {
            toast.error("Failed to load analytics data");
            setAnalyticsData({
                totalViews: 0,
                totalClicks: 0,
                totalEngagements: 0
            });
        } finally {
            setAnalyticsLoading(false);
        }
    }

    const getGreeting = () => {
        const hour = new Date().getHours();
        if (hour < 12) return 'Good Morning, Boss';
        if (hour === 12) return 'Helloo, Admin';
        if (hour < 15) return 'Hi! welcome, Administrator';
        if (hour < 18) return 'Good Afternoon, Boss';
        return 'Good Evening, Senior';
    };

    useEffect(() => {
        Counts();
        fetchAnalytics();
    }, []);

    useEffect(() => {
        const auth = localStorage.getItem('email');
        if (!auth) {
            history('/');
        }
    }, [history]);

    return (
        <>
            <Navbar />
            <Sidebar />
            <main id="main" className="main">
                <div className="pagetitle mt-3">
                    <h1 className="mt-3" style={{ fontSize: "40px", fontWeight: "bold" }}>
                        {getGreeting()}
                    </h1>
                </div>
                
                <article className="article dashboard mt-3">
                    <div className="row">
                        <div className="col-md-12">
                            {loading ? (
                                <div className="row justify-content-center text-center">
                                    <div className="info-card sales-card loading-card">
                                        <div className="text-center">
                                            <div className="loading-animation">
                                                <div className="loading-title"></div>
                                                <div className="loading-content">
                                                    <div className="loading-icon"></div>
                                                    <div className="loading-text">
                                                        <div className="loading-value"></div>
                                                        <div className="loading-badge"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="row mt-3">
                                    <div className="col-xxl-4 col-md-3">
                                        <div className="card info-card sales-card">
                                            <div className="card-body">
                                                <h5 className="card-title">Total <span>| Users</span></h5>
                                                <div className="d-flex align-items-center">
                                                    <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                                        <i className="bi bi-people"></i>
                                                    </div>
                                                    <div className="ps-3">
                                                        <h6>{count.totalUsers || 0}</h6>
                                                        <Link to=''>
                                                            <span className="badge bg-primary text-white">
                                                                <i className="bi bi-info-circle me-1"></i>View users
                                                            </span>
                                                        </Link>
                                                    </div>
                                                </div>  
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xxl-4 col-md-3">
                                        <div className="card info-card revenue-card">
                                            <div className="card-body">
                                                <h5 className="card-title">Total <span>| Upload(s)</span></h5>
                                                <div className="d-flex align-items-center">
                                                    <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                                        <i className="bi bi-list"></i>
                                                    </div>
                                                    <div className="ps-3">
                                                        <h6>{count.totalUpload || 0}</h6>
                                                        <Link to='/admin/questions'>
                                                            <span className="badge bg-success text-light">
                                                                <i className="bi bi-info-circle me-1"></i>View Upload(s)
                                                            </span>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xxl-4 col-md-3">
                                        <div className="card info-card revenue-card">
                                            <div className="card-body">
                                                <h5 className="card-title">Total <span>| Package(s)</span></h5>
                                                <div className="d-flex align-items-center">
                                                    <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                                        <i className="bi bi-list"></i>
                                                    </div>
                                                    <div className="ps-3">
                                                        <h6>{count.totalPackage || 0}</h6>
                                                        <Link to='/admin/packages'>
                                                            <span className="badge bg-success text-light">
                                                                <i className="bi bi-info-circle me-1"></i>View Package(s)
                                                            </span>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xxl-4 col-md-3">
                                        <div className="card info-card sales-card">
                                            <div className="card-body">
                                                <h5 className="card-title">Total <span>| Payments</span></h5>
                                                <div className="d-flex align-items-center">
                                                    <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                                        <i className="bi bi-coin"></i>
                                                    </div>
                                                    <div className="ps-3">
                                                        <h6>{count.totalPayment || 0}</h6>
                                                        <Link to=''>
                                                            <span className="badge bg-secondary text-light">
                                                                <i className="bi bi-info-circle me-1"></i>View Payments
                                                            </span>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    
                    {/* Quick Stats Summary */}
                    <div className="row mt-4">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">Platform Overview</h5>
                                    <div className="row">
                                        <div className="col-md-6 col-lg-3">
                                            <div className="d-flex align-items-center p-3 bg-light rounded-3 mb-3">
                                                <div className="me-3">
                                                    <i className="bi bi-check-circle-fill text-success fs-4"></i>
                                                </div>
                                                <div>
                                                    <div className="fw-bold">{count.totalTutor || 0}</div>
                                                    <small className="text-muted">Registered Tutor(s)</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-lg-3">
                                            <div className="d-flex align-items-center p-3 bg-light rounded-3 mb-3">
                                                <div className="me-3">
                                                    <i className="bi bi-link-45deg text-primary fs-4"></i>
                                                </div>
                                                <div>
                                                    <div className="fw-bold">{count.totalDownloads || 0}</div>
                                                    <small className="text-muted">Active Downloads</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-lg-3">
                                            <div className="d-flex align-items-center p-3 bg-light rounded-3 mb-3">
                                                <div className="me-3">
                                                    <i className="bi bi-coin text-warning fs-4"></i>
                                                </div>
                                                <div>
                                                    <div className="fw-bold">{count.totalPayment || 0}</div>
                                                    <small className="text-muted">Total Payments</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-lg-3">
                                            <div className="d-flex align-items-center p-3 bg-light rounded-3 mb-3">
                                                <div className="me-3">
                                                    <i className="bi bi-list text-info fs-4"></i>
                                                </div>
                                                <div>
                                                    <div className="fw-bold">{count.totalCat || 0}</div>
                                                    <small className="text-muted">Total Category</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="mt-4">
                                        <div className="alert alert-info mb-0">
                                            <div className="d-flex align-items-center">
                                                <i className="bi bi-info-circle-fill me-2"></i>
                                                <div>
                                                    <strong>Note:</strong> For detailed analytics charts and tables, please use the 
                                                    <Link to="/admin/categories" className="alert-link ms-1">Detailed Reports</Link> section.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </article>
            </main>
            <Footer />
        </>
    )
}

export default AdminDashboard;